import { z } from 'zod';
import { validator } from '@xeppt/xeppt-sdk';
import { prettifyStars } from '@utils/index';

interface ICardProps {
    messages: {
        first_name: string;
        last_name: string;
        card_number: string;
        expire: string;
        code: string;
    };
}

interface IBankProps {
    method: 'manual' | 'instant';
    messages: {
        account_name: string;
        transit_number: string;
        account_number: string;
        bank_number: string;
    };
}

export const linkCardValidation = ({ messages }: ICardProps) =>
    z.object({
        first_name: validator.firstName(messages.first_name),
        last_name: validator.lastName(messages.last_name),
        card_number: validator.cardNumber(messages.card_number),
        expire: validator.cardExpiration(messages.expire),
        code: validator.cardCVV(messages.code)
    });

export const linkBankValidation = ({ messages, method }: IBankProps) => {
    if (method === 'manual') {
        return z.object({
            account_number: validator.accountNumber(prettifyStars(messages.account_number)),
            transit_number: z.string().min(1, messages.transit_number),
            account_name: z.string().min(1, messages.account_name),
            bank_number: validator.accountType(messages.bank_number)
        });
    } else {
        return z.object({});
    }
};
